import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {property} from 'lit-element';

export const AB_OPT_IN_BANNER_ELEMENT_TAG = 'ab-opt-in-banner';

const newAudienceUrl = (id: number) => `/v2/dataset_groups/${id}/audiences/new`;
const oldAudienceUrl = (id: number) => `/dataset_groups/${id}/audiences/new`;

/**
 * Used to opt a user in/out of the ABV2 alpha.
 */
@customElement(AB_OPT_IN_BANNER_ELEMENT_TAG)
export default class AbOptInBanner extends FlywheelComponent {
  @property({type: Number})
  datasetGroupId?: number;

  @property({type: Boolean})
  optedIn = false;

  static get styles() {
    return [styles];
  }

  optIn() {
    if (!this.datasetGroupId) return;
    location.href = newAudienceUrl(this.datasetGroupId);
  }

  optOut() {
    if (!this.datasetGroupId) return;
    location.href = oldAudienceUrl(this.datasetGroupId);
  }

  render() {
    if (!this.datasetGroupId) return;

    if (this.optedIn) {
      return html`
        <div class="opt-in opt-in--out">
          <a @click=${() => this.optOut()} class="opt-in__action">
            <fly-icon icon="arrow_back"></fly-icon>
            Go back to the old builder
          </div>
        </div>
      `;
    }

    return html`
      <div class="opt-in">
        <div class="opt-in__badge">New</div>
        You're using our old audience builder.
        <a @click=${() => this.optIn()} class="opt-in__action">
          Switch to V2
          <fly-icon icon="arrow_forward"></fly-icon>
        </a>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [AB_OPT_IN_BANNER_ELEMENT_TAG]: AbOptInBanner;
  }
}
